import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { selectIsDebugInfoOn } from 'selectors/debugInfoSelector';

export const useDebugPostMessages = () => {
  const isDebugInfoOn: boolean = useSelector(selectIsDebugInfoOn);

  useEffect(() => {
    if (!isDebugInfoOn) {
      return;
    }

    const handleMessage = (event: MessageEvent) => {
      // eslint-disable-next-line no-console
      console.log('PORTAL Received:', event.data);
    };

    window.addEventListener('message', handleMessage);

    // Cleanup on component unmount
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [isDebugInfoOn]);
};
